import React from 'react'
import {
    Box,
    FormControlLabel,
    Switch,
    SxProps,
    Theme,
    Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface DataSwitchProps {
    fieldName: string
    value: boolean
    onChange: (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) => void
    labelStyle?: SxProps<Theme>
    containerStyle?: SxProps<Theme>
}

const SwitchComponent = ({
    fieldName,
    value,
    onChange,
    labelStyle,
    containerStyle,
}: DataSwitchProps) => {
    const { t: translate } = useTranslation()

    const defaultLabelStyle = {
        color: 'white',
        typography: 'label3',
        lineHeight: '19px',
        mt: '2px',
    }

    const containerBasicStyle = {
        display: 'flex',
        alignItems: 'center',
        mt: '8px',
        height: '28px',
    }

    return (
        <Box sx={{ ...containerBasicStyle, ...containerStyle }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={value}
                        onChange={onChange}
                        name={fieldName}
                        color="primary"
                    />
                }
                label={
                    <Typography sx={{ ...defaultLabelStyle, ...labelStyle }}>
                        {translate(fieldName)}
                    </Typography>
                }
            />
        </Box>
    )
}

export { SwitchComponent }
